<div class="csv-header">
  <span class="csv-header__icon" aria-hidden="true">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M14 3v5h5M8.5 12.5h7M8.5 16h7M12 12.5V19" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
  </span>
  <div class="csv-header__copy">
    <h5 class="csv-header__title">Upload tags from CSV</h5>
    <p class="csv-header__subtitle">Add one tag per row. Your CSV needs two columns:</p>
  </div>
  <button type="button" class="csv-header__close" (click)="close()" aria-label="Close">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
  </button>
</div>

<div class="csv-body">
  <div class="csv-columns">
    <div class="csv-column">
      <div class="csv-column__head"><span class="csv-column__letter">A</span>Tag</div>
      <p class="csv-column__text">The tag name.</p>
    </div>
    <div class="csv-column">
      <div class="csv-column__head"><span class="csv-column__letter">B</span>Show</div>
      <p class="csv-column__text"><code class="csv-code csv-code--show">show</code> or <code class="csv-code">hide</code>. Leave it blank to show the tag.</p>
    </div>
  </div>

  <p class="csv-muted">Hidden tags are saved but not shown to people writing stories.</p>

  <div class="csv-sample">
    <div class="csv-sample__head">
      <span>Example</span>
      <button type="button" class="csv-sample__download" (click)="downloadSample()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 4v11M7.5 11 12 15.5 16.5 11M5 20h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        Download sample CSV
      </button>
    </div>
    <table>
      <thead>
        <tr><th class="csv-sample__num"></th><th>Tag</th><th class="csv-sample__show">Show</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of sampleRows; let i = index">
          <td class="csv-sample__num">{{i + 2}}</td>
          <td>{{row.tag}}</td>
          <td class="csv-sample__show"><code class="csv-code" [class.csv-code--show]="row.show === 'show'">{{row.show}}</code></td>
        </tr>
      </tbody>
    </table>
  </div>

  <p class="csv-info">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 12a8 8 0 1 1-2.34-5.66M20 4v4.5h-4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
    <span>Tags that already exist are updated to match the Show column instead of being added twice.</span>
  </p>

  <label class="csv-mirror" *ngIf="showMirror">
    <input type="checkbox" [(ngModel)]="mirror">
    <span>{{mirrorLabel}}</span>
  </label>
</div>

<div class="csv-footer">
  <button (click)="close()" type="button" class="csv-btn csv-btn--ghost">Cancel</button>
  <button (click)="csvInput.click()" type="button" class="csv-btn csv-btn--primary">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 16V5M7.5 9.5 12 5l4.5 4.5M5 20h14" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>
    Choose CSV file
  </button>
  <input #csvInput type="file" accept=".csv,text/csv" hidden (change)="onFileSelected($event)">
</div>
